import { render, staticRenderFns } from "./appLinks.vue?vue&type=template&id=276bc4e2&"
var script = {}
import style0 from "./appLinks.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276bc4e2')) {
      api.createRecord('276bc4e2', component.options)
    } else {
      api.reload('276bc4e2', component.options)
    }
    module.hot.accept("./appLinks.vue?vue&type=template&id=276bc4e2&", function () {
      api.rerender('276bc4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/appLinks/appLinks.vue"
export default component.exports